
















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { StoreDetails } from '@shared/types/stores';
import { UCIcon } from '@shared/ui';

export default defineComponent({
  name: 'StoreContactInfo',
  components: {
    UCIcon,
  },
  props: {
    store: {
      type: Object as PropType<StoreDetails>,
      required: true,
    },
  },
  setup() {
    return {};
  },
});
